import { ref } from 'vue'
import { defineStore } from 'pinia'
import type { NotificationGroup } from './api/emailLinks'

/**
 * What the email link screens show. The auth modal renders views without
 * props, so the route handler that opened the link leaves its result here.
 */
export type EmailVerifiedStatus = 'success' | 'expired' | 'already'
export type EmailUpdatedStatus = 'success' | 'expired'

export const useEmailLinkStore = defineStore('emailLink', () => {
  const verifiedStatus = ref<EmailVerifiedStatus>('success')

  const updatedStatus = ref<EmailUpdatedStatus>('success')
  const updatedEmail = ref('')

  /** Kept for Undo: the same signed token turns the group back on. */
  const unsubscribeToken = ref('')
  const unsubscribedGroup = ref<NotificationGroup>('newsletter')

  const alertToken = ref('')
  const alertProductUrl = ref<string | null>(null)

  const secureToken = ref('')

  return {
    verifiedStatus,
    updatedStatus,
    updatedEmail,
    unsubscribeToken,
    unsubscribedGroup,
    alertToken,
    alertProductUrl,
    secureToken,
  }
})
